<template>
  <span class="flex items-center justify-center">
    <MembershipCard :name="name" class="w-full" />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import MembershipCard from '@/shared/components/MembershipCard.vue'
import { useUserStore } from '@/shared/stores/user'

const userStore = useUserStore()
const name = computed(() => userStore.user?.name ?? '')
</script>
